import { StorageBucket } from './storage-bucket'
import { StorageBucketConfig } from './storage-bucket-config'
export interface ImgParams { width?: number, height?: number, quality?: number }

export class ImgBucket extends StorageBucket {

  constructor(data: StorageBucketConfig) {
    super(data)
  }

  public getUrl(key: string, params: ImgParams = {}): string {
    let url = this.getUrl(key)
    if (params.width || params.height || params.quality) {
      url += '?x-oss-process=image';
    } else {
      return url;
    }
    if (params.quality) { url += `/quality,q_${params.quality}`; }
    if (params.width) {
      if (params.height) {
        url += `/resize,m_fill,w_${params.width},h_${params.height}`;
      } else {
        url += `/resize,w_${params.width}`;
      }
    } else {
      if (params.height) { url += `/resize,h_${params.height}`; }
    }
    return url
  }

  public get_url_of_width(key: string, width: number): string {
    return key ? `${this.get_url(key)}?x-oss-process=image/resize,w_${width}` : null
  }

  public get_url_of_height(key: string, height: number): string {
    return key ? `${this.get_url(key)}?x-oss-process=image/resize,h_${height}` : null
  }

  public get_url_of_square(key: string, width: number): string {
    return key ? `${this.get_url(key)}?x-oss-process=image/resize,m_fill,h_${width},w_${width}/quality,q_50` : null
  }

  public get_url_of_quality(key: string, quality: number): string {
    return key ? `${this.get_url(key)}?x-oss-process=image/quality,q_${quality}` : null
  }

  public get_url_wq(key: string, width: number, quality: number): string {
    return key ? `${this.get_url(key)}?x-oss-process=image/resize,w_${width}/quality,q_${quality}` : null
  }

  public get_url_of_style(key: string, width: number): string {
    return `${this.get_url(key)}@!w${width}`
  }

}



// WEBPACK FOOTER //
// ./src/app/models/media/img-bucket.ts